import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

export interface ContactSupportRequest {
  subject: string;
  message: string;
  file?: File | null;
}

// TODO: Wire with backend
@Injectable()
export class SupportService {
  readonly enabled = false;

  submitContactRequest(_request: ContactSupportRequest): Observable<void> {
    return of(undefined);
  }
}
